import React from "react";


function Certificates() {
    return (<>
        <div id="certificates">
            <div>
                <div className="center-text">
                    <h2 className="text-black mt-0">Makalelerim</h2>
                    <hr className="divider divider-light"/>
                </div>
                <div className="image-grid">

                    <div>
                        <a className="portfolio-box" href="https://link.springer.com/chapter/10.1007/978-3-031-40395-8_9">
                            <img src="/assets/img/certificates/thumbnails/k_makale_spring.png"
                                 alt="..."/>

                        </a>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="center-text">
                    <h2 className="text-black mt-0">Sertifikalarım</h2>
                    <hr className="divider divider-light"/>
                </div>
                <div className="image-grid">






                    <div>
                        <a className="portfolio-box"
                           href="/assets/img/certificates/fullsize/b_linux_administration.png">
                            <img
                                src="/assets/img/certificates/thumbnails/k_linux_administration.png" alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_linux_essential.png">
                            <img src="/assets/img/certificates/thumbnails/k_linux_essential.png"
                                 alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_linux_network.png">
                            <img src="/assets/img/certificates/thumbnails/k_linux_network.png"
                                 alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_linux_track.png">
                            <img src="/assets/img/certificates/thumbnails/k_linux_track.png"
                                 alt="..."/>
                        </a>
                    </div>

                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_linux_technician.png">
                            <img src="/assets/img/certificates/thumbnails/k_linux_technician.png"
                                 alt="..."/>
                        </a>
                    </div>
                </div>


                <div className="center-text">
                    <h2 className="text-black mt-0">Katılım Belgeleri</h2>
                    <hr className="divider divider-light"/>
                </div>
                <div className="image-grid">
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_tubitak_eimza.png">

                            <img src="/assets/img/certificates/thumbnails/k_tubitak_eimza.png"
                                 alt="..."/>
                        </a>

                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_content_manager.png">

                            <img src="/assets/img/certificates/thumbnails/k_content_manager.png"
                                 alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_java.png">

                            <img src="/assets/img/certificates/thumbnails/k_java.png" alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_was.png">
                            <img src="/assets/img/certificates/thumbnails/k_was.png" alt="..."/>
                        </a>
                    </div>
                    <div>
                        <a className="portfolio-box" href="/assets/img/certificates/fullsize/b_spring.png">
                            <img src="/assets/img/certificates/thumbnails/k_spring.png"
                                 alt="..."/>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </>);
}

export default Certificates;